export const ADMIN_DEFAULT_INVITER = "seyum@radium.cloud";

export const BULK_IMPORT_ROW_HEIGHT = 36; // px
export const BULK_IMPORT_MAX_VISIBLE_ROWS = 12;
